import { MouseEventHandler } from 'react';
import { LeftArrow, RightArrow } from 'shared-widget-components/src/components/Icons';

interface ArrowButtonsProps {
  prevSlide: MouseEventHandler<HTMLButtonElement>;
  nextSlide: () => void;
}

/**
 * ArrowButtons component
 * this component is responsible for rendering the arrow buttons in the carousel
 * @param prevSlide - the previous slide function
 * @param nextSlide - the next slide function
 * @returns ArrowButtons component
 */

export const ArrowButtons = ({ prevSlide, nextSlide }: ArrowButtonsProps) => {
  return (
    <div className='flex gap-2'>
      <button type='button' className=' bg-[#F2F2F2] text-black w-10 h-10 rounded-full flex items-center justify-center outline-none focus:border-none focus:outline-none' onClick={prevSlide}>
        <LeftArrow />
      </button>
      <button type='button' className=' bg-[#F2F2F2] text-black w-10 h-10 rounded-full flex items-center justify-center outline-none focus:border-none focus:outline-none' onClick={nextSlide}>
        <RightArrow />
      </button>
    </div>
  );
};
